import { withLocationState } from 'modules/common/hoc';
import CredentialsListsLayout from './CredentialsListsLayout';

export default withLocationState(CredentialsListsLayout);
